import { memo } from 'react'

import { SVGProps } from '../types/iconType'

export const TwitchIcon = memo(({ style, className }: SVGProps) => {
  return (
    <svg style={style} className={className} viewBox="0 0 33 32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.833 1.82C1.833.815 2.65 0 3.657 0h25.686c1.007 0 1.824.815 1.824 1.82v18.15c0 .482-.193.945-.534 1.286l-4.317 4.307a1.826 1.826 0 0 1-1.289.533H17.83l-5.473 5.46c-.949.948-2.571.277-2.571-1.062v-4.398h-6.13a1.821 1.821 0 0 1-1.823-1.82V1.82zm2.379.553v21.35h6.129c1.007 0 1.823.815 1.823 1.82v2.85l4.147-4.137a1.825 1.825 0 0 1 1.289-.533h7.197l3.991-3.983V2.373H4.212zm9.86 5.063c.657 0 1.19.532 1.19 1.187v6.759c0 .655-.533 1.187-1.19 1.187-.656 0-1.189-.532-1.189-1.187v-6.76c0-.654.533-1.186 1.19-1.186zm7.953 0c.657 0 1.19.532 1.19 1.187v6.759c0 .655-.533 1.187-1.19 1.187-.657 0-1.19-.532-1.19-1.187v-6.76c0-.654.533-1.186 1.19-1.186z"
        fillRule="evenodd"
      />
    </svg>
  )
})
